import { render, staticRenderFns } from "./ReportDocumentDate.vue?vue&type=template&id=252813ea&scoped=true&"
import script from "./ReportDocumentDate.vue?vue&type=script&lang=js&"
export * from "./ReportDocumentDate.vue?vue&type=script&lang=js&"
import style0 from "./ReportDocumentDate.vue?vue&type=style&index=0&id=252813ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252813ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
